/* Indian Baddies — prelaunch JS (Shopify build)
   Re-inits on shopify:section:load so the theme customizer never blanks content. */
(function () {
  "use strict";
  var $ = function (s) { return document.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(document.querySelectorAll(s)); };
  var CFG = window.PRE_CFG || {};
  var reduced = window.matchMedia("(prefers-reduced-motion:reduce)").matches;

  var tT;
  function toast(m) {
    var t = $("#toast"); if (!t) return;
    t.textContent = m;
    requestAnimationFrame(function () { t.classList.add("on"); });
    clearTimeout(tT); tT = setTimeout(function () { t.classList.remove("on"); }, 2800);
  }

  /* ---- the growing list counter (curve + real joins from shop metafield + this device) ---- */
  function baseCount(now) {
    var t = (now - CFG.launchTs) / (CFG.countDays * 864e5);
    if (t <= 0) return CFG.countStart;
    if (t >= 1) return CFG.countTarget + Math.floor((now - CFG.launchTs - CFG.countDays * 864e5) / 864e5 * CFG.countAfterPerDay);
    var e = 1 - Math.pow(1 - t, 2.2);
    return Math.round(CFG.countStart + (CFG.countTarget - CFG.countStart) * e);
  }
  function localJoins() { try { return parseInt(localStorage.getItem("ib_joins") || "0", 10); } catch (e) { return 0; } }
  function count() { return baseCount(Date.now()) + (CFG.joinsBase || 0) + localJoins(); }
  function fmt(n) { return n.toLocaleString("en-IN"); }
  function paintCount() {
    $$("[data-count]").forEach(function (el) { el.textContent = fmt(count()); });
    $$("[data-next]").forEach(function (el) { el.textContent = "Nº " + String(count() + 1).padStart(4, "0"); });
  }

  /* ---- socials auto-drift ---- */
  function social(base, perWeek) {
    var n = base + Math.floor((Date.now() - CFG.launchTs) / (7 * 864e5) * perWeek);
    return n >= 1e6 ? (n / 1e6).toFixed(1).replace(/\.0$/, "") + "M" : Math.round(n / 1000) + "K";
  }
  function paintSocials() {
    $$("[data-ig]").forEach(function (el) { el.textContent = social(CFG.igBase, CFG.igPerWeek); });
    $$("[data-yt]").forEach(function (el) { el.textContent = social(CFG.ytBase, CFG.ytPerWeek); });
  }

  window.goJoin = function () {
    var j = $("#join"); if (!j) return;
    j.scrollIntoView({ behavior: reduced ? "auto" : "smooth" });
    setTimeout(function () { var i = $("#jName"); if (i) i.focus({ preventScroll: true }); }, reduced ? 0 : 700);
  };

  /* ---- nav tint ---- */
  window.addEventListener("scroll", function () {
    var nav = $("#nav"); if (nav) nav.classList.toggle("lit", window.scrollY > window.innerHeight * 0.82);
  }, { passive: true });

  /* ---- rules scroll story ---- */
  function storyTick() {
    var story = $("#story"); if (!story) return;
    if (reduced) { story.dataset.stage = "3"; return; }
    var r = story.getBoundingClientRect(), total = story.offsetHeight - window.innerHeight;
    var p = Math.min(1, Math.max(0, -r.top / Math.max(1, total)));
    var st = p < .25 ? 1 : p < .5 ? 2 : p < .78 ? 3 : 4;
    if (story.dataset.stage !== String(st)) story.dataset.stage = String(st);
  }
  window.addEventListener("scroll", storyTick, { passive: true });

  /* ---- THE CARD ---- */
  function me() { try { return JSON.parse(localStorage.getItem("ib_me")); } catch (e) { return null; } }
  function drawCard(name, numLabel) {
    var c = $("#regCard"); if (!c) return;
    var x = c.getContext("2d"), W = c.width, H = c.height;
    x.fillStyle = "#1a0d05"; x.fillRect(0, 0, W, H);
    var g = x.createRadialGradient(W / 2, H * .32, 80, W / 2, H * .32, 900);
    g.addColorStop(0, "rgba(225,29,42,.20)"); g.addColorStop(1, "rgba(225,29,42,0)");
    x.fillStyle = g; x.fillRect(0, 0, W, H);
    x.strokeStyle = "#B08B4F"; x.lineWidth = 4; x.strokeRect(54, 54, W - 108, H - 108);
    x.strokeStyle = "rgba(176,139,79,.35)"; x.lineWidth = 2; x.strokeRect(78, 78, W - 156, H - 156);
    x.textAlign = "center";
    x.fillStyle = "#B08B4F"; x.font = "600 30px 'Hanken Grotesk',sans-serif";
    x.fillText("T H E   B A D D I E   L I S T", W / 2, 330);
    x.fillStyle = "#E11D2A"; x.font = "86px Samarkan, Fraunces, serif";
    x.fillText("indian baddies", W / 2, 470);
    x.fillStyle = "#f0e2c6"; x.font = "300 34px Fraunces,Georgia,serif";
    x.fillText("From the house of", W / 2, 540);
    x.fillStyle = "#E11D2A"; x.font = "46px Samarkan, Fraunces, serif";
    x.fillText("raj gharana", W / 2, 600);
    x.strokeStyle = "rgba(176,139,79,.5)"; x.lineWidth = 2;
    x.beginPath(); x.moveTo(W / 2 - 180, 670); x.lineTo(W / 2 + 180, 670); x.stroke();
    x.fillStyle = "#f0e2c6"; x.font = "italic 300 54px Fraunces,Georgia,serif";
    x.fillText(name, W / 2, 800);
    x.fillStyle = "#E11D2A"; x.font = "italic 900 124px Fraunces,Georgia,serif";
    x.fillText(numLabel, W / 2, 970);
    x.fillStyle = "rgba(240,226,198,.75)"; x.font = "italic 300 34px Fraunces,Georgia,serif";
    x.fillText("First look. Every drop. 48 hours early.", W / 2, 1080);
    x.fillStyle = "rgba(240,226,198,.5)"; x.font = "600 24px 'Hanken Grotesk',sans-serif";
    x.fillText("A  L I M I T E D  C O L L E C T I O N", W / 2, 1350);
    x.fillStyle = "rgba(240,226,198,.35)"; x.font = "500 22px 'Hanken Grotesk',sans-serif";
    x.fillText("Made in India · For India", W / 2, 1400);
    var dl = $("#dlCard"); if (dl) dl.href = c.toDataURL("image/png");
  }
  function paintCard() {
    if (!$("#regCard")) return;
    var m = me();
    document.fonts.ready.then(function () {
      if (m) {
        drawCard(m.name, "Nº " + String(m.num).padStart(4, "0"));
        var n = $("#cardNote"); if (n) n.innerHTML = "Your card, " + m.name + " · saved to this device";
        var a = $("#cardActions"); if (a) a.classList.add("on");
        var f = $("#joinForm"); if (f) f.style.display = "none";
      } else drawCard("— your name here —", "Nº " + String(count() + 1).padStart(4, "0"));
    });
  }

  /* Shopify validates contact[phone] strictly — normalise to E.164 (+91 default for bare Indian numbers) */
  function normPhone(raw) {
    var p = raw.replace(/[^\d+]/g, "");
    if (p.charAt(0) === "+") return p;
    if (p.length === 10) return "+91" + p;
    if (p.length === 11 && p.charAt(0) === "0") return "+91" + p.slice(1);
    if (p.length === 12 && p.indexOf("91") === 0) return "+" + p;
    return "+" + p;
  }

  /* Welcome email with THE card: draw it, capture it, hand it to the mail robot
     (Apps Script webhook in Theme settings), THEN submit. 4s cap — the robot
     must never be able to block a signup. */
  function sendCard(name, em, ph, num, done) {
    var fin = false;
    var finish = function () { if (!fin) { fin = true; done(); } };
    setTimeout(finish, 4000);
    try {
      document.fonts.ready.then(function () {
        drawCard(name, "Nº " + String(num).padStart(4, "0"));
        var c = $("#regCard");
        var img = "";
        try { img = c ? c.toDataURL("image/jpeg", 0.85) : ""; } catch (e) {}
        fetch(CFG.hook, {
          method: "POST", mode: "no-cors",
          headers: { "Content-Type": "text/plain" },   /* simple request — no CORS preflight, Apps Script-friendly */
          body: JSON.stringify({ email: em, name: name, phone: ph, num: num, img: img })
        }).then(finish, finish);
      }, finish);
    } catch (e) { finish(); }
  }

  window.joinBaddies = function (e) {
    e.preventDefault();
    var name = ($("#jName") && $("#jName").value || "").trim(),
        em = ($("#jEmail") && $("#jEmail").value || "").trim(),
        ph = ($("#jPhone") && $("#jPhone").value || "").trim();
    if (!name) { toast("Tell us your name — it goes on the card"); $("#jName").focus(); return false; }
    if (!em || em.indexOf("@") < 1) { toast("A valid email gets you the drop access link"); $("#jEmail").focus(); return false; }
    if (!ph || ph.replace(/\D/g, "").length < 10) { toast("Your WhatsApp number gets you drop updates"); $("#jPhone").focus(); return false; }
    ph = normPhone(ph);
    if ($("#jPhone")) $("#jPhone").value = ph;
    var num = count() + 1;
    if ($("#jNote")) $("#jNote").value = "Baddie Nº " + String(num).padStart(4, "0") + " · WhatsApp: " + ph;
    try {
      localStorage.setItem("ib_joins", String(localJoins() + 1));
      localStorage.setItem("ib_me", JSON.stringify({ name: name, email: em, phone: ph, num: num }));
    } catch (err) {}
    var f = $("#joinForm");
    var proceed = function () {
      if (f && f.getAttribute("action")) { f.submit(); return; } // Shopify's native customer form → Admin → Customers (tag: baddie). Proven reliable — don't AJAX this.
      paintCount(); paintCard();
      toast("Baddie Nº " + String(num).padStart(4, "0") + " — you're in, " + name);
    };
    if (CFG.hook) { toast("Minting your card…"); sendCard(name, em, ph, num, proceed); return false; }
    proceed();
    return false;
  };

  function bindOnce(el, key, fn) { if (el && !el.dataset[key]) { el.dataset[key] = "1"; fn(el); } }

  function bindShare() {
    bindOnce($("#shareCard"), "bound", function (btn) {
      btn.addEventListener("click", function () {
        var c = $("#regCard"); if (!c) return;
        c.toBlob(function (blob) {
          var f = new File([blob], "baddie-card.png", { type: "image/png" });
          if (navigator.share && navigator.canShare && navigator.canShare({ files: [f] })) {
            navigator.share({ files: [f], title: "The Baddie List", text: "I'm on the Baddie List." });
          } else { var d = $("#dlCard"); if (d) d.click(); toast("Card saved — share it to your story"); }
        });
      });
    });
  }
  /* In-app browsers (Instagram/FB) dump <a download> into Files, not Photos.
     Route through the native share sheet instead — "Save Image" there lands in Photos. */
  function bindSave() {
    bindOnce($("#dlCard"), "bound", function (btn) {
      btn.addEventListener("click", function (e) {
        if (!navigator.share) return;              // no Share API → let the plain <a download> run as-is
        e.preventDefault();                          // must fire synchronously, before toBlob resolves
        var c = $("#regCard"); if (!c) return;
        c.toBlob(function (blob) {
          var f = new File([blob], "baddie-card.png", { type: "image/png" });
          if (navigator.canShare && navigator.canShare({ files: [f] })) {
            navigator.share({ files: [f], title: "The Baddie List", text: "I'm on the Baddie List." }).catch(function () {});
          } else {
            var a = document.createElement("a");
            a.href = c.toDataURL("image/png"); a.download = "baddie-card.png";
            document.body.appendChild(a); a.click(); a.remove();
          }
        });
      });
    });
  }

  /* ---- gated vote ---- */
  function paintVote() { var v = null; try { v = localStorage.getItem("ib_vote"); } catch (e) {} $$(".sw").forEach(function (o) { o.classList.toggle("voted", o.dataset.c === v); }); }
  function bindVote() {
    $$(".sw").forEach(function (o) {
      bindOnce(o, "bound", function () {
        o.addEventListener("click", function () {
          if (!me()) { toast("Voting is a Baddie thing — join the list first"); goJoin(); return; }
          try { localStorage.setItem("ib_vote", o.dataset.c); } catch (e) {}
          paintVote(); toast("Voted " + o.dataset.c + " — Drop 02 first access is yours");
        });
      });
    });
  }

  /* ---- accordions ---- */
  window.toggleAcc = function (btn) {
    var acc = btn.parentElement, body = acc.querySelector(".acc-b");
    var open = acc.classList.toggle("on");
    body.style.maxHeight = open ? body.scrollHeight + "px" : "0";
  };
  function openFirstAcc() {
    $$(".acc.on .acc-b").forEach(function (b) { b.style.maxHeight = b.scrollHeight + "px"; });
  }

  /* ---- init (runs on load AND every customizer section reload) ---- */
  function initAll() {
    paintCount(); paintSocials(); paintCard(); paintVote(); bindVote(); bindShare(); bindSave(); openFirstAcc(); storyTick();
  }
  initAll();
  window.addEventListener("load", initAll);
  setInterval(paintCount, 45000 + Math.floor(Math.random() * 30000)); // ticks up while watching
  document.addEventListener("shopify:section:load", initAll);
  document.addEventListener("shopify:section:select", initAll);
  if (location.search.indexOf("customer_posted=true") > -1) {
    var m2 = me();
    toast(m2 ? "Baddie Nº " + String(m2.num).padStart(4, "0") + " — you're in, " + m2.name : "You're on the Baddie List");
  }
})();
